/**
 * @generated SignedSource<<500e0cc5c40d60505a64a0a75d931c50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderWithComplexMenuDesktop_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAuthenticatedUser_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": "__isViewer"
};

node.hash = "3df1b08d9073afe8dc149c8563ecaeb8";

module.exports = node;
